import React from "react";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";

export const DialogComponent = ({
  open,
  handleOK,
  handleCancel,
  title,
  contentText,
  children,
  actionDisabled=false,
  cancelText='Close',
  okText='Yes',
  hideCancel=false,
  hideOk=false,
  fullWidth=false,
  maxWidth,  
  ...props
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      fullWidth
      maxWidth={maxWidth || "sm"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        {contentText && (
          <DialogContentText id="alert-dialog-description">
            {contentText}
          </DialogContentText>
        )}
        {children}
      </DialogContent>
      <DialogActions>
        {!hideCancel && (
          <Button onClick={handleCancel} color="primary">
          {cancelText}
          </Button>
        )}
        {!hideOk && (
          <Button onClick={handleOK} color="primary" variant="contained" disabled={actionDisabled}>
            {okText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export const ErrorDialog = ({
  open,
  handleCancel,
  title='Error',
  contentText,
  severity="error",
  cancelText='OK',
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth={"sm"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <Alert severity={severity} >
          {contentText && (
            <DialogContentText id="alert-dialog-description">
              {contentText}
            </DialogContentText>
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}